/**
 * @ngdoc filters
 * @memberof mercury.filters
 * @name purchaseordernumber
 */
angular.module('mercury.filters.purchaseordernumber', [])
.filter('purchaseordernumber', function() {
  return function(order) {
    var paddedNumber = (order && order.orderNumber) ? order.fullOrderNumber.toString() : '0';
    while (paddedNumber.length < 6) {
      paddedNumber = '0' + paddedNumber;
    }

    return ((order && order.creditRequest) ? 'CR' : 'PO') + '#' + paddedNumber;
  };
});
